






















import {Component, Prop, Vue} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import {DateTime} from 'luxon';
import {BookingDialogEntry, nil} from '@/common';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';
import BookingListItem from '@/components/Views/Dashboard/Booking/BookingListItem.vue';
import {groupBy} from 'lodash';
import UserRoleMixin from "@/mixins/UserRoleMixin.vue";
import CardholderInfoBadge from "@/components/Views/UI/CardholderInfoBadge.vue";
import {getZonedBookingDate} from '@/utils';

@Component({
    components: {
        CardholderInfoBadge,
        BookingListItem,
        GenericDialog,
    },
})
export default class BookingDateDialog extends Mixins(UserRoleMixin) {
    public open = false;
    public groupMode = false;
    public displayLocal = false;

    @Prop({default: () => []})
    public bookings!: BookingDialogEntry[];

    get groupLabel(){
        return this.groupMode ? "Grouping by Cardholder" : "Grouping By Status";
    }
    public get tzLabel(){
        return `Displaying ${this.displayLocal ? "Local": "Booking"} Timezone`
    }

    get dateHeader(): string {
        if (nil(this.bookings)) {
            return '';
        }
        for (const b of this.bookings) {
            if (b.content.length === 0) {
                continue;
            }
            if (!nil(b.content[0])) {

                return getZonedBookingDate(b.content[0]).toFormat('DDDD');
            }
        }
        return '';
    }
    public onBookingChanged(group, id, newBooking) {
        this.bookings[group].content[id] = newBooking;
    }

    public get bookingsGroupedByCardholder(){
        const flattened = this.bookings.map(x=>x.content).flat();
        const grouped = groupBy(flattened, 'cardholder');
        const output = [];
        for(const name of Object.keys(grouped).reverse()){
            output.push({
                content:grouped[name],
                title: name === 'undefined' ? 'None' : name,
            });
        }
        return output;
    }

    public get bookingsGrouped(){
        return this.groupMode ? this.bookingsGroupedByCardholder : this.bookings;
    }


    public purchaserPhoneFor(content){
        if(nil(content[0])){
            return null;
        } else {
            return content[0].purchaserModel.phone;
        }
    }
    public purchaserEmailFor(content){
        if(nil(content[0])){
            return '';
        } else {
            return content[0].purchaserModel.email;
        }
    }
    public cardHolderNameFor(content){
        if(nil(content[0])){
            return null;
        } else {
            return content[0].cardholder ? content[0].cardholder : 'No Cardholder Name Found';
        }
    }
}
